import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { UiNotificationService } from 'src/app/features/ui-notifications/ui-notification.service';
import { Observable } from 'rxjs';

export interface ConfirmModel {
  message: string;
  header?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  icon?: string;
}

@Injectable({
  providedIn: 'root',
})
export class UiConfirmService {
  constructor(
    private readonly confirmationService: ConfirmationService,
    private readonly t: TranslateService,
    private readonly translateService: TranslateService,
    private readonly notificationService: UiNotificationService,
  ) {
  }

  confirmDiscardChanges(message?: string) {
    return new Promise<boolean>((resolve) => {
      this.confirmationService.confirm({
        message: message ?? this.t.instant('common.unsavedEdits'),
        header: this.t.instant('common.confirm'),
        acceptLabel: this.t.instant('common.doNotDiscard'),
        rejectLabel: this.t.instant('common.discard'),
        acceptButtonStyleClass: 'tw-btn-primary',
        rejectButtonStyleClass: 'tw-btn-transparent',
        icon: '',
        accept: () => {
          resolve(false);
        },
        reject: (rejectionType: number) => {
          const rejectButtonClickType = 1;
          if (rejectionType !== rejectButtonClickType) {
            resolve(false);
            return;
          }
          this.notificationService.success(this.translateService.instant('common.changesDiscarded'));
          resolve(true);
        },
        defaultFocus: 'accept',
      });
    });
  }

  confirm(options: ConfirmModel) {
    return new Observable<boolean>((observer) => {
      this.confirmationService.confirm({
        header: options.header ?? this.t.instant('common.confirm'),
        message: options.message,
        acceptLabel: options.acceptLabel ?? this.t.instant('common.confirm'),
        rejectLabel: options.rejectLabel ?? this.t.instant('buttons.reject'),
        icon: options.icon,
        accept: () => {
          observer.next(true);
          observer.complete();
        },
        reject: () => {
          observer.next(false);
          observer.complete();
        },
      });
    });
  }
}
